export default __webpack_public_path__ + "static/media/Maintenance.f7ad0b45.png";